import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";

import { Paths } from "../common/constants";
import { RootState } from "../redux/store";
import { useAppSelector } from "../hooks/useAppSelector";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { getUserProfile } from "../pages/profile/services/action";
import { captureEvent, identifyAnalyticsUser } from "../common/utils";

const PageViewTracker = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { sdkHasLoaded, user } = useDynamicContext();
  const isLoggedIn = useIsLoggedIn();
  const { userData } = useAppSelector((state: RootState) => state.profileSlice);

  const isAuthRoute = [
    Paths.SIGNIN,
    Paths.VERIFY,
    Paths.SIGNUP,
    Paths.SUPPORT,
    Paths.SIGNIN_EMAIL,
    Paths.PASSKEY_SETUP,
    Paths.SUPPORT_SUCCESS,
    Paths.PASSKEY_SUCCESS,
    Paths.REGISTER_SUCCESS,
  ].includes(location.pathname as any);

  useEffect(() => {
    if (sdkHasLoaded && isLoggedIn && !isAuthRoute && !userData?._id) {
      dispatch(getUserProfile());
    }
  }, [sdkHasLoaded, isLoggedIn, isAuthRoute, userData?._id, dispatch]);

  useEffect(() => {
    if (user) {
      const phoneCred = user.verifiedCredentials?.find(
        (cred: any) => cred.format === "phoneNumber",
      );
      const rawPhone =
        phoneCred?.phoneNumber ||
        user.phoneNumber ||
        userData?.mobileNumber ||
        "";
      const cleanPhone = rawPhone.replace(/^\+1/, "") || "";

      const distinctId = cleanPhone || user.email || user.userId;

      if (distinctId) {
        identifyAnalyticsUser(distinctId, {
          phoneNo: cleanPhone,
        });
      }
    }
  }, [user, userData?.mobileNumber]);

  useEffect(() => {
    const currentUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

    captureEvent("$pageview", {
      $current_url: currentUrl,
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      timestamp: new Date().toISOString(),
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default PageViewTracker;
